import React from "react";

import classes from "./styles.module.scss";

const colorsOptions = {
    all: {
        bgColor: "#DEFCF8",
        textColour: "#0EB0A9",
    },
    none: {
        bgColor: "#FFF0F0",
        textColour: "#AC0D34",
    },
    number: {
        bgColor: "#F0F8FD",
        textColour: "#0049C6",
    },
};

const FilterStatus = ({ numSelected, maxNumSelection }) => {
    const status = numSelected === 0 ? "none" : numSelected > 0 && numSelected !== maxNumSelection ? "number" : "all";

    return (
        <div className={classes.filterStatusContainer} style={{ backgroundColor: colorsOptions[status].bgColor }}>
            <span style={{ color: colorsOptions[status].textColour }}>
                {(() => {
                    switch (status) {
                        case "none":
                            return "-";
                        case "number":
                            return `${numSelected}`;
                        default:
                            return "All";
                    }
                })()}
            </span>
        </div>
    );
};

export default FilterStatus;
